import React from 'react'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

export const Wrapper: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
}

export const HeaderRow: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
}

export const HeaderRowWithSpacing: React.CSSProperties = {
  ...HeaderRow,
  marginTop: toPx(sharedStyles.Spacings.MEDIUM),
}

export const Header: React.CSSProperties = {
  ...sharedStyles.small,
  color: sharedStyles.Colors.SECONDARY,
}

export const Text: React.CSSProperties = {
  ...sharedStyles.text,
}
